import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from '@material-ui/core/Button';
import TwilioComponent from "./twilioComponent"
import Tooltip from '@material-ui/core/Tooltip';
import StartVisitStyle from "../../styles/startVisitStyle";

const CustomTooltip = withStyles((theme) => ({
    tooltip: {
        border: "1px solid #4D4D4D",
        "background-color": "#FFFFFF",
        "box-shadow": "5px 5px 5px 0 rgba(0,0,0,0.5)",
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: "0",
        lineHeight: "17px",
        minWidth: 410
    },
}))(Tooltip);

class StartVisit extends React.Component {
    constructor(props) {
        super(props);
        this.state = { startVisit: false }
    }

    timeDiff = (dt2, dt1) => {
        var diffMs = (dt2 - dt1);
        return Math.floor(diffMs / 1000 / 60);
    }

    startVisit = () => {
        let { GetTokenAndStartVist, selectedCardData } = this.props;
        let { DoctorId } = selectedCardData;
        GetTokenAndStartVist && GetTokenAndStartVist({ userId: DoctorId })
    }

    getNotesTabInfo = () => {
        const {
            getOrderNotes = async () => {},
            getPatientNotes = async () => {},
            getMedicalOrderNotes = async () => {},
            getMedicalPatientNotes = async () => {},
            selectedCardData: { OrderId, UserId },
        } = this.props;

        if (OrderId) {
            getOrderNotes({ OrderId });
            getMedicalOrderNotes({ OrderId });
            getMedicalPatientNotes({ OrderId });
        }

        if (UserId) {
            getPatientNotes({ UserId });
        }
    }

    render() {
        let { classes, selectedCardData, loading, selectedPrescriberInfo, callStarted, SetStartVisit, isVideoFocused, CallDetails, callDetailSent, CallEnd, LogError } = this.props;
        const { EndDateTime_UTC = new Date(), StartDateTime_UTC = new Date() } = selectedCardData;
        const today = new Date();
        const endDateTimeDiff = this.timeDiff(new Date(EndDateTime_UTC), today);
        const startDateTimeDiff = this.timeDiff(new Date(StartDateTime_UTC), today);
        const isEndTimeRange = endDateTimeDiff > 10 && startDateTimeDiff <= 0;
        const isStartTimeRange = startDateTimeDiff < 10 && endDateTimeDiff >= 0;
        const VisitButton = ((isEndTimeRange || isStartTimeRange) ?
            <Button
                onClick={this.startVisit}
                disabled={false}
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
            >
                Start Visit
            </Button> :
            <CustomTooltip placement="right" title="The current time is not within the Scheduled Visit time window." >
                <span className={classes.tooltipStyle}>
                    <Button
                        onClick={() => { }}
                        disabled={true}
                        variant="contained"
                        color="primary"
                        className={classes.buttonStyle}
                    >
                        Start Visit
            </Button>
                </span>
            </CustomTooltip>)
        return (
            <div className={classes.visitWrapper}>
                {VisitButton}
                {callStarted ? <TwilioComponent
                    loading={loading}
                    LogError={LogError}
                    callDetailSent={callDetailSent}
                    endVisit={CallEnd}
                    CallDetails={CallDetails}
                    isVideoFocused={isVideoFocused}
                    callStarted={callStarted}
                    SetStartVisit={SetStartVisit}
                    selectedPrescriberInfo={selectedPrescriberInfo}
                    selectedCardData={selectedCardData}
                    startVisit={this.state.startVisit}
                    version={1}
                    getNotesTabInfo={this.getNotesTabInfo}
                /> : null}
            </div>
        )
    }
}


export default withStyles(StartVisitStyle)(StartVisit);

